import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useQuery } from 'react-query'
import { AxiosResponse } from 'axios'
import { tsWhoAmI } from '../../Typescript/API_Response'
import PyAPI from '../Python/APIs/PyAPI'
import { useUserContext } from '../../Contexts/UserConfig'

export function usePyGet(
  path: string[],
  enabled: boolean = true,
  auth?: tsWhoAmI | undefined,
  options?: { onSuccess?: (data: any) => void },
) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useQuery<any, AxiosResponse>(
    ['PyAPI', ...path],
    () => PyAPI.get(auth ?? whoAmI, path.join('')),
    {
      onError: (err) => setError(err),
      enabled: (!!auth || !!whoAmI) && enabled,
      ...options,
    },
  )
}
